import { OverflowMenu, OverflowMenuItem } from "@carbon/react";

export const View = ({ navigateToEdit, openDeleteModal }) => {
  return (
    <OverflowMenu
      focusTrap={false}
      data-floating-menu-container
      size="sm"
      flipped
    >
      {/* <OverflowMenuItem itemText="Change name" /> */}
      <OverflowMenuItem itemText="Edit" onClick={navigateToEdit} />
      <OverflowMenuItem
        className="delete-link"
        itemText="Delete"
        onClick={openDeleteModal}
        hasDivider
      />
    </OverflowMenu>
  );
};
